import { render, staticRenderFns } from "./RegistrarEntrega.vue?vue&type=template&id=2063b30c&"
import script from "./RegistrarEntrega.vue?vue&type=script&lang=js&"
export * from "./RegistrarEntrega.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports